import React, { useState } from 'react';
import styled from 'styled-components';
import AnvendelseSpecifikSelect from './AnvendelseSpecifikSelect';
import { neutral } from '../../../style/colors';
import { anvspec as anvSpec, getAnvspecForKode } from '../../Map/util/koder';
import FilterListItem from './FilterListItem';

const AnvendelseSpecifik = (props: IAnvendelseSpecifikProps) => {
  const { toggledAnvspecs, setToggledAnvspecs } = props;
  const [showSelect, setShowSelect] = useState(false);
  const removeAnvspec = kode => {
    setToggledAnvspecs([...toggledAnvspecs.filter(k => k !== kode)]);
  };
  const renderAnvspecs = () => {
    return toggledAnvspecs.map((kode: number) => {
      const anvspec = anvSpec.find(a => a.kode === kode);
      return (
        <div key={anvspec.kode} style={{ width: '50%' }}>
          <FilterListItem
            onClick={removeAnvspec}
            backgroundColor={neutral[600]}
            kode={getAnvspecForKode(anvspec.kode)}
            toggled={true}
          />
        </div>
      );
    });
  };
  return (
    <Wrapper>
      <AnvendelseSpecifikSelect
        show={showSelect}
        toggledAnvspecs={toggledAnvspecs}
        addAnvspec={kode => {
          setToggledAnvspecs([...toggledAnvspecs, kode]);
        }}
      />
      <TilfojButton
        onClick={() => {
          setShowSelect(!showSelect);
        }}
      >
        <span>+</span>
        <span>Tilføj specifik anvendelse</span>
      </TilfojButton>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {renderAnvspecs()}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
`;
const TilfojButton = styled.div`
  height: 50px;
  line-height: 50px;
  font-weight: 600;
  cursor: pointer;
  :hover {
    background-color: ${neutral[150]};
  }
  span {
    margin-left: 10px;
    font-size: 15px;
    &:first-child {
      font-size: 22px;
      font-weight: 700;
      margin-left: 20px;
    }
  }
`;
interface IAnvendelseSpecifikProps {
  toggledAnvspecs: Array<number>;
  setToggledAnvspecs: Function;
}
export default AnvendelseSpecifik;
